export const SWAGGER_PIECE_NAME_PREFIX = 'swagger_'

export enum SwaggerRequestProps {
    PATH = 'path',
    BODY = 'body',
    HEADER = 'header',
    QUERY = 'query',
}

export const MAX_REFRESH_TOKEN_ATTEMPTS = 2
